// stripe.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';

import { StripeTransactionInfo } from '../models/stripe.model';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

  // Stripe Checkout
  stripeCheckout(purchaseDetails: StripeTransactionInfo): Observable<any> {
    const apiUrl = `/onlinetesting/rest/eCommerce/stripeCheckout`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
    const requestData = purchaseDetails;

    return this.httpClient.post(apiUrl, requestData, { headers: headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      })
    );
  }

  createUID(): string {
    // Generate a random UUID
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }
}
